import {isAllPagesModeEnabled} from './signaturePageMode';

export const applySignaturePageMode = (request) => {
    if (!isAllPagesModeEnabled()) return request;

    return {
        ...request,
        all_pages: true,
    };
};
